import { render, staticRenderFns } from "./MobileBalanceBlock.vue?vue&type=template&id=d799b470&scoped=true&"
import script from "./MobileBalanceBlock.vue?vue&type=script&lang=js&"
export * from "./MobileBalanceBlock.vue?vue&type=script&lang=js&"
import style0 from "./MobileBalanceBlock.vue?vue&type=style&index=0&id=d799b470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d799b470",
  null
  
)

export default component.exports